import { render, staticRenderFns } from "./SrmHeader.vue?vue&type=template&id=5e0ac34c&scoped=true"
import script from "./SrmHeader.vue?vue&type=script&lang=js"
export * from "./SrmHeader.vue?vue&type=script&lang=js"
import style0 from "./SrmHeader.vue?vue&type=style&index=0&id=5e0ac34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0ac34c",
  null
  
)

export default component.exports